module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_25-b5bc9ee931bdcc0c439702898a9dc0d2.jpg";